import React from "react";
import ProfitStatusBadge from "../components/ProfitStatusBadge";
import { profitReportCards, profitReportHistory } from "../data/profitData";

function ProfitReportIcon({ type, fallback }) {
  if (type === "performance") {
    return (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <circle cx="9" cy="9" r="6.5" stroke="currentColor" strokeWidth="1.5" />
        <path d="M9 9l4-2.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <circle cx="9" cy="9" r="1.5" fill="currentColor" />
      </svg>
    );
  }

  if (type === "payout") {
    return (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <rect x="3" y="4" width="12" height="10" rx="1" stroke="currentColor" strokeWidth="1.5" />
        <path d="M3 7h12M1 4h16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    );
  }

  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-label={fallback}>
      <rect x="3" y="2" width="12" height="14" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
      <path d="M6 7h6M6 9.5h6M6 12h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

export default function ProfitReportsPage() {
  return (
    <div className="profit-page">
      <div className="profit-page-header">
        <div className="profit-page-title">Reports</div>
        <div className="profit-page-subtitle">
          Download and review your partner reports
        </div>
      </div>

      <div className="profit-report-grid">
        {profitReportCards.map(function renderCard(card) {
          return (
            <div className="profit-report-card" key={card.title}>
              <div className="profit-report-icon">
                <ProfitReportIcon type={card.icon} fallback={card.title} />
              </div>
              <div className="profit-report-title">{card.title}</div>
              <div className="profit-report-description">{card.description}</div>
              <button className="profit-button profit-button-outline profit-report-button" type="button">
                {card.action}
              </button>
            </div>
          );
        })}
      </div>

      <div className="profit-card">
        <div className="profit-card-header">
          <div className="profit-card-title">Report History</div>
        </div>
        <div className="profit-table-wrap">
          <table className="profit-table">
            <thead>
              <tr>
                <th>Report</th>
                <th>Period</th>
                <th>Generated</th>
                <th>Status</th>
                <th>Download</th>
              </tr>
            </thead>
            <tbody>
              {profitReportHistory.map(function renderRow(item) {
                return (
                  <tr key={item.report + item.generated}>
                    <td>{item.report}</td>
                    <td>{item.period}</td>
                    <td>{item.generated}</td>
                    <td>
                      <ProfitStatusBadge status={item.status} />
                    </td>
                    <td>
                      <button className="profit-button profit-button-ghost" type="button">
                        PDF · CSV
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
